export default "/dist/files/icone_electricite.3495579917f8293fba28494fc40153cd.svg";